
export default function(o, onTogglePlay){

  var projectLabel = o.util.getTranslation(o, 'project')
  var rollLabel = o.util.getTranslation(o, 'roll')

  var projectDiv =
    $('<div>')
    .css({
      display: 'inline-block',
      margin: '0.3rem',
    })
    .html('project 000')

  var rollDiv =
    $('<div>')
    .css({
      display: 'inline-block',
      margin: '0.3rem',
    })
    .html('roll 00')

  var spacerDiv = function(){
    var spacer =
      $('<div>')
      .css({
        display: 'inline-block',
        margin: '0.3rem',
      })
      .html('&nbsp;/&nbsp;')
    return spacer
  }

  var timecodeDiv =
    o.component.timecode(o)

  var playDiv =
    o.component.play(o, true, onTogglePlay)

  var setCurrentMarker = function(marker){

    var project = marker.roll.split('-')[0]
    var roll = marker.roll.split('-')[1]

    projectDiv.html(`${projectLabel} ${project}`)
    rollDiv.html(`${rollLabel} ${roll}`)

  }

  var div =
    $('<div>')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      fontSize: o.fontSizeDef.s,
      padding: "0.7rem",
    })
    .append([
      projectDiv,
      o.component.spacer(o),
      rollDiv,
      o.component.spacer(o),
      timecodeDiv,
      o.component.spacer(o),
      playDiv,
      o.component.spacer(o),
      o.component.sound(o),
    ])

  div.updateTimecode = timecodeDiv.update
  div.setCurrentMarker = setCurrentMarker
  div.togglePlay = playDiv.toggle

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/antiArchiveTag/footer/footer.js